import { render } from "./ProductItemSeller.vue?vue&type=template&id=39320d64&scoped=true"
import script from "./ProductItemSeller.vue?vue&type=script&lang=js"
export * from "./ProductItemSeller.vue?vue&type=script&lang=js"

import "./ProductItemSeller.vue?vue&type=style&index=0&id=39320d64&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39320d64"]])

export default __exports__